import Block from './Block'
import HTML from '../html'
import Modal from '../modal'

export default class Karriarer extends Block {
    
    constructor(contentRoot) {
        super(contentRoot)
        
        this.links = this.root.find('.kl-karriar__link')
        this.cache = {}
        
        this.links.each((i, l) => {
            if (l.getAttribute('target') !== '__blank') {
                $(l).on('click', event => {
                    event.preventDefault()
                    this.requestKarriar(l.dataset.karriarId, modal => modal.show())
                })
            }
        })
    }
    
    _updateArbitraryScripts() {
        this.root.find('form input[type=\'file\']').on('change', event => {
            let p = $(event.target).closest('p'),
                val = /([\\/])?([^\\/]+$)/i.exec(event.target.value)[2]
            p.find('.filename').remove()
            p.append(`<span class="filename">${val}</span>`)
        })
    }
    
    requestKarriar(id, callback) {
        if (typeof this.cache[id] !== 'undefined') {
            if (typeof callback === 'function') {
                callback(this.cache[id])
            }
            return this
        }
        var m = new Modal()
        m.runPreloader()
        
        if (typeof callback === 'function') {
            callback(m)
        }
        
        $.ajax({
            url: ajaxurl,
            method: 'POST',
            data: {
                action: 'fetchSingleKarriar',
                karriarId: id,
            },
            success: data => {
                if (data.karriarSinglePage) {
                    m.defineContent(data.karriarSinglePage)
                    this._updateArbitraryScripts()
                    this.cache[id] = m
                } else {
                    console.warn('AJAX error:', data)
                }
            },
        })
        return this;
    }
}

